// meta.requireAuth: precisa estar logado | meta.guestOnly: logado é redirecionado ao painel
export default [
    {
        name: 'login',
        path: '/login',
        component: () => import('@/views/Login.vue'),
        meta: {
            guestOnly: true
        }
    },
    {
        // link do e-mail: /recuperar-senha?token=...
        name: 'recuperar-senha',
        path: '/recuperar-senha',
        component: () => import('@/views/RecuperarSenha.vue')
    },
    {
        name: 'main',
        path: '/',
        component: () => import('@/views/Main.vue'),
        meta: {
            requireAuth: true
        },
        children: [
            {
                name: 'dashboard',
                path: '',
                component: () => import('@/views/Principal.vue')
            },
            {
                name: 'novo-lancamento',
                path: 'novo-lancamento',
                component: () => import('@/views/NovoLancamento.vue')
            },
            {
                name: 'compras',
                path: 'compras',
                component: () => import('@/views/Compras.vue')
            },
            {
                name: 'vendas',
                path: 'vendas',
                component: () => import('@/views/Vendas.vue')
            },
            {
                name: 'estoque',
                path: 'estoque',
                component: () => import('@/views/Estoque.vue')
            },
            {
                name: 'clientes',
                path: 'clientes',
                component: () => import('@/views/Clientes.vue')
            },
            {
                name: 'materiais',
                path: 'materiais',
                component: () => import('@/views/Materiais.vue')
            },
            {
                name: 'fornecedores',
                path: 'fornecedores',
                component: () => import('@/views/Fornecedores.vue')
            },
            {
                name: 'despesas',
                path: 'despesas',
                component: () => import('@/views/Despesas.vue')
            },
            {
                name: 'relatorios',
                path: 'relatorios',
                component: () => import('@/views/Relatorios.vue')
            },
            {
                name: 'saldo',
                path: 'saldo',
                component: () => import('@/views/Saldo.vue')
            }
        ]
    }
]
